<template>
  <div>
    <b-button
      block
      :variant="$store.state.appConfig.layout.skin === 'dark' ? 'dark' : ''"
      class="d-md-none mb-1"
      @click="isHidden = !isHidden"
    >
      <div>
        <feather-icon
          icon="MenuIcon"
          :class="$store.state.appConfig.layout.isRTL ? 'left-position' : 'right-position'"
          size="20"
        />
      </div>
    </b-button>
    <b-card
      class="mb-2 rounded remove-padding"
      :class="(isHidden ? 'd-md-block  d-none' : '')"
    >
      <b-tabs
        v-model="tabNumber"
        :class="$store.state.appConfig.layout.skin === 'dark' ? 'custom-tab-bg-blue' :'custom-tab-bg-aliceblue'"
        content-class="col-12 col-md-12 mt-1 mt-md-0"
        pills
        nav-wrapper-class="col-md-12 col-12"
        class="row pannelIB-tab"
        @input="findTab"
      >
        <b-tab
          v-for="tab in filtredtabsItem"
          :key="tab.number+'ibtabs'"
          active
          title-item-class="w-100 w-md-200"
          @click="tabClick(tab)"
        >
          <!-- title -->
          <template
            v-if="!tab.hidden"
            #title
          >
            <div :class="$store.state.appConfig.layout.skin === 'dark' ? 'text-white' :''">
              <component
                :is="tab.icon"
                class="mr-50"
              />
              <span class="font-weight-bold default">
                {{ $t(tab.title) }}
              </span>
            </div>
          </template>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import {
  BIconBorderAll,
} from 'bootstrap-vue'
import profileTabs from '@/views/logics/profile/profileTabs'

export default {
  components: {
    BIconBorderAll,
  },
  mixins: [profileTabs],

}
</script>
  <style lang="scss" scoped>
  ::v-deep.router-link-exact-active {
    color:white
  }
.custom-tab-bg-aliceblue ::v-deep.nav-pills .nav-link.active{
  background-color: $primary !important;
}
.custom-tab-bg-aliceblue ::v-deep.nav-pills .nav-link{
  background-color: aliceblue  ;

}
.custom-tab-bg-blue ::v-deep.nav-pills .nav-link{
  background-color: rgb(155, 190, 221);

}
[dir] .tabs ::v-deep.nav-pills .nav-link{
  margin: 3px !important;
}
.remove-padding .card-body{
  padding: 0;
}
  </style>
